import axiosClient from "@/api/common/axiosClient.ts";
import { AuthenticationResponse } from "@/types/authentication.ts";

export const changeClient = (token: string) => {
  return axiosClient.get<AuthenticationResponse>("users/change_client/", {
    headers: { authorization: `Bearer ${token}` },
  });
};
